module.exports = __webpack_public_path__ + "static/media/anquan.9e95648e.png";